import React from 'react';

import ProfileImage from 'js/components/profile_image';
import SocialUsernameLink from 'js/components/social_username_link';

import {getSocialAccountUrl} from 'js/common/social_helper';

import './index.scss';

export default function SocialUsernameWithAvatar({profileImageUrl, socialId, platform}) {
    const url = getSocialAccountUrl(platform, socialId);
    return (
        <div className="social-username-with-avatar">
            <div className="social-username-with-avatar__avatar">
                <ProfileImage imageUrl={profileImageUrl} sourceUrl={url} />
            </div>
            <div className="social-username-with-avatar__username">
                <SocialUsernameLink platform={platform} socialLinkId={socialId}>
                    {socialId}
                </SocialUsernameLink>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/social_username_with_avatar/index.js